import { Component, Input } from '@angular/core';

export enum Icon {

  defaultIcon = <any>'pointer_location',
  //inicatotrs
  camera_indicator = <any>'camera_indicator',
  basura_indicator = <any>'basura_indicator',
  air_indicator = <any>'air_indicator',
  parking_indicator = <any>'parking_indicator',
  sound_indicator = <any>'sound_indicator',
  // Material
  account_circle_ng = <any>'account_circle',
  arrow_forward_ng = <any>'arrow_forward',
  assessment_ng = <any>'assessment',
  calendar_ng = <any>'calendar_today',
  camera_ng = <any>'camera',
  center_focus_ng = <any>'center_focus_strong',
  check_ng = <any>'check',
  check_circle = <any>'check_circle',
  chevron_left_ng = <any>'chevron_left',
  chevron_right_ng = <any>'chevron_right',
  close_ng = <any>'close',
  highlight_off = <any>'highlight_off',
  home_w = <any>'home_w',
  home_ng = <any>'home',
  keyboard_arrow_down_ng = <any>'keyboard_arrow_down',
  layers_ng = <any>'layers',
  layer_luminary = <any>'layer_luminary',
  layer_garbage = <any>'layer_garbage',
  map_ng = <any>'map',
  menu_ng = <any>'menu',
  navigation_ng = <any>'navigation',
  near_me_ng = <any>'near_me',
  photo_camera_ng = <any>'photo_camera',
  plus_one_ng = <any>'plus_one',
  settings_ng = <any>'settings',
  time_ng = <any>'access_time',
  traffic_ng = <any>'traffic',
  traffic_y = <any>'traffic_y',
  traffic_24 = <any>'traffic_24',
  train_ng = <any>'train',
  tram_ng = <any>'tram',
  transit_enterexit_ng = <any>'transit_enterexit',
  videocam_ng = <any>'videocam',
  arrow_down = <any>'arrow_down',

  // SVG PNG
  arrow_right_blue = <any>'arrow_right_blue',
  camera_panel_group = <any>'camera-panel-group',
  cards_w = <any>'icon_cards',
  check_circle_green = <any>'check_circle_green',
  list_grid_w = <any>'icon_listgrid',
  help_blue = <any>'help_blue',
  audit_y = <any>'audit_y',
  camera = <any>'camera',
  camera_w = <any>'camera_w',
  camera_g = <any>'camera_g',
  camera_green = <any>'camera_green',
  camera_ly = <any>'camera_ly',
  oil = <any>'icono-aceite',
  camera_lpr = <any>'camera-lpr',
  platforms = <any>'platforms',
  tm_logo = <any>'tm_logo',
  logo_sit = <any>'logo-sit',
  sisem_logo = <any>'sisem_logo',
  camera_lpr_map = <any>'map-camera-lpr',
  hit_and_run = <any>'icono-atropellamiento',
  mud = <any>'icono-barro',
  fallen_trees = <any>'icono-caida-arboles',
  fallen_rocks = <any>'icono-caida-rocas',
  layer_cameras = <any>'icono-capa-cameras',
  sensor_id = <any>'sensor-id',
  layer_photodetection = <any>'icono-capa-fotodeteccion',
  clock_w = <any>'clock_w',
  device = <any>'device',
  layer_tolls = <any>'icono-capa-peajes',
  layer_traffic = <any>'icono-capa-trafico',
  layer_trucks = <any>'icono-capa-camiones',
  layer_speed = <any>'icono-capa-velocidad',
  layer_runt = <any>'icono-capa-runt',
  layers_white = <any>'icono-capas-white',
  layers_black = <any>'icono-capas-black',
  layers_yellow = <any>'icono-capas-yellow',
  layer_general_green = <any>'icono-capa-general-green',
  layer_traffic_green = <any>'icono-capa-traffic-green',
  layer_traffic_yellow = <any>'icono-capa-traffic-yellow',
  layer_incidents_green = <any>'icono-capa-incidents-green',
  layer_agents_green = <any>'icono-capa-agents-green',
  layer_cars_green = <any>'icono-capa-cars-green',
  layer_cameras_green = <any>'icono-capa-cameras-green',
  layer_cranes_green = <any>'icono-capa-cranes-green',
  layer_scooter = <any>'icono-capa-scooter',
  layer_bicycle = <any>'icono-capa-bicycle',
  layer_stop_bus = <any>'icono-capa-parada-bus',
  layer_co2 = <any>'map-sensor',
  layers = <any>'icono-capas',
  logout = <any>'logout',
  login = <any>'login',
  road_weather = <any>'icono-carretera-clima',
  road_no_weather = <any>'icono-carretera-noclima',
  crash = <any>'icono-choque',
  surface_condition = <any>'icono-condicion-superficie',
  conditions = <any>'icono-condiciones',
  speed_control_white = <any>'icono-controlvelocidad-white',
  speed_control = <any>'icono-controlvelocidad',
  slide = <any>'icono-deslizamiento',
  addresses = <any>'icono-direcciones',
  equipment_failure = <any>'icono-fallo-equipo',
  photodetection = <any>'icono-fotodeteccion',
  road_management = <any>'icono-gestion-carretera',
  net_management = <any>'icono-gestion-red',
  speed_management = <any>'icono-gestion-velocidad',
  hail = <any>'icono-granizo',
  damaged_infrastructure = <any>'icono-infraestructura-danada',
  general_instructions = <any>'icono-instrucciones-generales',
  flood = <any>'icono-inundacion',
  rain = <any>'icono-lluvia',
  bad_conditions = <any>'icono-malas-condiciones',
  demonstration = <any>'icono-manifestacion',
  fog = <any>'icono-niebla',
  not_found = <any>'icono-not-found',
  programmed_works = <any>'icono-obras-programadas',
  env_obstruction = <any>'icono-obstruccion-ambiental',
  anima_obstruction = <any>'icono-obstruccion-animal',
  general_obstruction = <any>'icono-obstruccion-general',
  vehicular_obstruction = <any>'icono-obstruccion-vehicular',
  tolls_white = <any>'icono-peajes-white',
  tolls = <any>'icono-peajes',
  animal_presence = <any>'icono-presencia-animal',
  photo_signal = <any>'icono-senal-foto',
  situations_white = <any>'icono-situaciones-white',
  situations = <any>'icono-situaciones',
  construction_work = <any>'icono-trabajo-construccion',
  maintenance_work = <any>'icono-trabajo-mantenimiento',
  abnormal_traffic = <any>'icono-trafico-anormal',
  traffic_white = <any>'icono-trafico-white',
  traffic = <any>'icono-trafico',
  wind = <any>'icono-viento',
  rollover = <any>'icono-volcamiento',
  road_object = <any>'iconos-objeto-via',
  pack = <any>'icons-pack',
  calendar_outlined = <any>'icono-calendar-outlined',
  calendar_outlined_white = <any>'icono-calendar-outlined-white',
  calendar_outlined_blue = <any>'icono-calendar-outlined-blue',
  account = <any>'account',
  account_w = <any>'account_w',
  account_orange = <any>'account_orange',
  alert_w = <any>'alert',
  alert_ly = <any>'alert_ly',
  alert_green = <any>'alert_green',
  alert_orange = <any>'alert_orange',
  agents_w = <any>'agents',
  agents_green = <any>'agents_green',
  add = <any>'add',
  add_ = <any>'add_w',
  add_b = <any>'add_b',
  agency = <any>'agency',
  agency_w = <any>'agency_w',
  cameras_circle_w = <any>'cameras',
  camera_play_green = <any>'cameras_green',
  capacity_w = <any>'capacity_w',
  capacity_green = <any>'capacity_green',
  capacity_y = <any>'capacity_y',
  cars_w = <any>'cars',
  cars_ly = <any>'cars_ly',
  cars_blue = <any>'cars_blue',
  cars_cian = <any>'cars_cian',
  cars_yellow = <any>'cars_yellow',
  car_key = <any>'car-key',
  cctv = <any>'cctv',
  cctv_w = <any>'cctv_w',
  check_box_outilne = <any>'check_box_outilne',
  check_box_selected = <any>'check_box_selected',
  climate_w = <any>'climate',
  climate_green = <any>'climate_green',
  co2_green = <any>'CO2_green',
  co2_w = <any>'CO2_w',
  co2_ly = <any>'CO2_ly',

  concordance_w = <any>'concordance_w',
  concordance_green = <any>'concordance_green',
  delete = <any>'delete',
  document = <any>'document',
  document_w = <any>'document_w',
  download = <any>'download',
  download_document = <any>'download_document',
  download_pdf = <any>'download_document_pdf',
  edit = <any>'edit',
  email = <any>'email',
  email_w = <any>'email_w',
  folder = <any>'folder',
  humidity_w = <any>'humidity_w',
  google_logo = <any>'google',
  info = <any>'info',
  info_w = <any>'info_w',
  layers_s = <any>'layers_s',
  layers_w = <any>'layers_w',
  last_hours_w = <any>'last_hours_w',
  last_hours_green = <any>'last_hours_green',
  location_w = <any>'location_w',
  location_green = <any>'location_green',
  manage_accounts = <any>'manage_accounts',
  manage_accounts_w = <any>'manage_accounts_w',
  map_s = <any>'map_s',
  map_w = <any>'map_w',
  map_b = <any>'map_b',
  map_incident_purple = <any>'active-situation-purple',
  map_incident_green = <any>'situation_incident',
  map_event_purple = <any>'inactive-event',
  map_event_green = <any>'inactive-event-green',

  no_panel = <any>'no_panel',
  close_x = <any>'close-x',

  situation_incident = <any>'situation_incident',
  situation_event = <any>'inactive-event',
  in_complaints = <any>'map-in-complaints',
  in_conciliated = <any>'map-in-conciliated',
  in_crane = <any>'map-in-crane',
  in_inmobilizations = <any>'map-in-inmobilizations',
  in_road = <any>'map-in-road',
  in_schedule = <any>'map-in-schedule',
  in_signal = <any>'map-in-signal',
  in_traffic = <any>'map-in-traffic',
  in_alert2 = <any>'alert-2',
  monitoring_services = <any>'monitoring_services',
  monitoring_services_w = <any>'monitoring_services_w',
  parameters = <any>'parameters',
  parameters_w = <any>'parameters_w',
  photodetection_s = <any>'photodetection_s',
  photodetection_w = <any>'photodetection_w',
  play_arrow_w = <any>'play_arrow_w',
  play_arrow = <any>'play_arrow',
  pmv_w = <any>'pmv_w',
  pmv_b = <any>'pmv_b',
  pmv_green = <any>'pmv_green',
  pmv_yellow = <any>'pmv_yellow',
  pressure_w = <any>'pressure_w',
  processed_info = <any>'processed_info',
  processed_info_w = <any>'processed_info_w',
  processed_monitoring = <any>'processed_monitoring',
  search = <any>'search',
  search_w = <any>'search_w',
  sensor_b = <any>'sensor_b',
  sensor_w = <any>'sensor_w',
  sensor_b_camera = <any>'sensor_b_camera',
  sensor_w_camera = <any>'sensor_w_camera',
  sensor_ly = <any>'sensor_ly',
  sensor_OD = <any>'sensor_OD',
  luminary_w = <any>'luminary_w',
  luminary_blue = <any>'luminary_blue',
  luminary_green = <any>'luminary_green',
  luminary_grey = <any>'luminary_grey',
  power_white = <any>'power_white',
  dimmer_white = <any>'dimmer_white',
  settings_white = <any>'settings_white',
  lamp_rays = <any>'lamp_rays',
  clock_clockwise = <any>'clock_clockwise',
  sliders = <any>'sliders',
  settings_key_white = <any>'settings_key_white',
  layer_luminary_on = <any>'layer_luminary_on',
  layer_luminary_off = <any>'layer_luminary_off',
  layer_luminary_no_signal = <any>'layer_luminary_no_signal',
  garbage_w = <any>'garbage_w',
  garbage_full = <any>'garbage_full',
  garbage_middle = <any>'garbage_middle',
  garbage_empty = <any>'garbage_empty',
  camera_OD_map = <any>'camera_OD',
  camera_OD = <any>'cameras-od',
  sensor_green = <any>'sensor_green',
  settings_s = <any>'settings_s',
  settings_w = <any>'settings_w',
  situations_s = <any>'situations_s',
  situations_w = <any>'situations_w',
  temperature_w = <any>'temperature_w',
  toll_roads = <any>'toll_roads',
  toll_roads_w = <any>'toll_roads_w',
  traffic_arrows = <any>'traffic_arrows',
  traffic_marker = <any>'traffic-icon',
  traffic_s = <any>'traffic_s',
  traffic_w = <any>'traffic_w',
  trucks = <any>'trucks',
  trucks_w = <any>'trucks_w',
  users = <any>'users',
  users_w = <any>'users_w',
  time = <any>'time',
  speed = <any>'speed',
  speed_green = <any>'speed_green',
  speed_w = <any>'speed_w',
  speed_y = <any>'speed_y',
  flow = <any>'flow',
  flows = <any>'flows',
  flow_w = <any>'flow_w',
  road = <any>'road',
  road_w = <any>'road_w',
  roads = <any>'roads',
  roads_w = <any>'roads_w',
  speed_range = <any>'speed-range',
  traffic_sit = <any>'traffic-sit-icon',
  lock = <any>'lock',
  person = <any>'person',
  pedestrian_adult = <any>'pedestrian_adult',
  pedestrian_kid = <any>'pedestrian_kid',
  pedestrian_female = <any>'pedestrian_female',
  visibility_on = <any>'visibility_on',
  visibility_off = <any>'visibility_off',
  panic_button = <any>'boton-panico',
  layer_panic_button = <any>'icono-capa-boton-panico',
  layer_panic_button_b = <any>'icono-capa-boton-panico-b',
  results = <any>'results',
  forward = <any>'forward',
  backward = <any>'backward',
  nextward = <any>'nextward',
  bicycles = <any>'bicycles',
  bicycle_g = <any>'bicycle_g',
  bicycle_w = <any>'bicycle_w',
  bicycles_cian = <any>'bicycles_cian',
  bicycles_blue = <any>'bicycles_blue',
  pending_green = <any>'pending_green',
  distance_green = <any>'distance_green',
  direction_green = <any>'direction_green',
  road_green = <any>'road_green',
  road_y = <any>'road_y',
  street_addresses = <any>'street_addresses',
  road_width_green = <any>'road_width_green',
  speed_range_green = <any>'speed_range_green',
  bicycles_green = <any>'bicycles_green',
  panel_backward = <any>'arrow_back',
  lupa = <any>'lupa',
  lock_reset = <any>'lock_reset',
  lock_reset_dark = <any>'lock_reset_dark',
  lock_reset_white = <any>'lock_reset_white',
  check = <any>'check',
  questions = <any>'questions',
  bus = <any>'bus',
  bus_w = <any>'bus_w',
  bus_g = <any>'bus_g',
  bus_y = <any>'bus_y',
  scooter = <any>'scooter',
  scooter_y = <any>'scooter_y',
  scooter_g = <any>'scooter_g',
  map_parking = <any>'map_parking',
  motorcycle_green = <any>'motorcycle_green',
  matrix = <any>'matrix',
  OD_matrix = <any>'OD_matrix',
  OD_matrix_y = <any>'OD_matrix_y',
  OD_matrix_b = <any>'OD_matrix_b',
  underground_parking = <any>'underground_parking',
  parking = <any>'parking',
  parking_green = <any>'parking_green',
  parking_da_green = <any>'parking_da_green',
  parking_dc_green = <any>'parking_dc_green',
  parking_lva_green = <any>'parking_lva_green',
  parking_lvc_green = <any>'parking_lvc_green',
  parking_sa_green = <any>'parking_sa_green',
  parking_sc_green = <any>'parking_sc_green',
  access_green = <any>'access_green',
  active_green = <any>'active_green',
  lightbulb_green = <any>'lightbulb_green',
  operation_green = <any>'operation_green',
  poste_green = <any>'poste_green',
  side_green = <any>'side_green',
  sound_green = <any>'sound_green',
  title_camera_management = <any>'title_camera_management',
  title_panel_aforo = <any>'title_panel_aforo',
  title_panel_luminary = <any>'title_panel_luminary',
  traffic_light = <any>'traffic_light',
  traffic_light_green = <any>'traffic_light_green',
  map_traffic_light = <any>'map_traffic_light',
  pointer_map = <any>'pointer_location',
  number_symbol = <any>'number_symbol',
  plus = <any>'plus',
  layer_aforo = <any>'aforo-marker',
  van_green = <any>'van_green',
  trucks_green = <any>'trucks_green',
  others_green = <any>'others_green',
  map_agents_police = <any>'map-agents-police',
  map_agents_transit = <any>'map-agents-transit',
  map_zones_blue = <any>'map-blue-z',
  map_zones_orange = <any>'map-orange-z',
  map_zones_white = <any>'map-white-z',
  map_zones_yellow = <any>'map-yellow-z',
  active_agent = <any>'active-agent',
  active_agent_green = <any>'active-agent-green',
  filter = <any>'filter',
  filter_w = <any>'filter_w',
  police_agent = <any>'police-agent',
  transit_agent = <any>'transit-agent',
  calendar_green = <any>'calendar_green',
  pause_green = <any>'pause_green',
  play_green = <any>'play_green',
  schedule = <any>'schedule',
  pmt = <any>'pmt',
  map_pmt = <any>'map-pmt',
  closures = <any>'closures',
  company = <any>'company',
  contractor = <any>'contractor',
  pmt_green = <any>'pmt_green',
  bus_stop = <any>'bus-stop',
  bus_stop_green = <any>'bus-stop-green',
  map_bus_stop = <any>'map-bus-stop',
  admin = <any>'admin',
  bus_route = <any>'bus-route',
  bus_stop_type = <any>'bus-stop-type',
  dot = <any>'dot',
  dots = <any>'dots',
  modal_autority = <any>'modal_autority',
  modal_traffic_light = <any>'modal_traffic_light',
  modal_traffic_lights_damage = <any>'modal_traffic_lights_damage',
  modal_traffic_lights_operation = <any>'modal_traffic_lights_operation',
  modal_agents = <any>'modal_agents',
  modal_register = <any>'modal_register',
  modal_schedule = <any>'modal_schedule',
  moda_road_report_type = <any>'moda_road_report_type',
  modal_road = <any>'modal_road',
  modal_zone = <any>'modal_zone',
  modal_damage_type = <any>'modal_damage_type',
  modal_signal_type = <any>'modal_signal_type',
  modal_signals = <any>'modal_signals',
  modal_cancellation_crane = <any>'modal_cancellation_crane',
  modal_crane = <any>'modal_crane',
  modal_accident = <any>'modal_accident',
  modal_bus = <any>'modal_bus',
  modal_conciliated = <any>'modal_conciliated',
  modal_severity = <any>'modal_severity',
  modal_inmobilizations = <any>'modal_inmobilizations',
  modal_mobile = <any>'modal_mobile',
  modal_plate = <any>'modal_plate',
  modal_infraction_code = <any>'modal_infraction_code',
  modal_complaint_state = <any>'modal_complaint_state',
  modal_complaint_type = <any>'modal_complaint_type',
  modal_complaints = <any>'modal_complaints',
  zones = <any>'zones',
  zones_green = <any>'zones_green',
  map_zones = <any>'map_zones',
  zone_type = <any>'zone_type',
  zone_condition = <any>'zone_condition',
  zone_capacity = <any>'zone_capacity',
  zone_lenght = <any>'zone_lenght',
  zone_width = <any>'zone_width',
  zone_schedule = <any>'zone_schedule',
  zone_motorcycle = <any>'zone_motorcycle',
  zone_cars = <any>'zone_cars',
  roads_green = <any>'roads_green',
  road_widht = <any>'road_widht',
  road_lenght = <any>'road_lenght',
  road_sentido = <any>'road_sentido',
  road_type = <any>'road_type',
  road_velocidad = <any>'road_velocidad',
  road_capacity = <any>'road_capacity',
  map_accident = <any>'map_accident',
  accident = <any>'accident',
  accident_green = <any>'accident_green',
  severity = <any>'severity',
  sector = <any>'sector',
  edit_pmv = <any>'icono-edit-pmv',
  consulta_pmv = <any>'icono-consulta-pmv',
  consulting_pmv = <any>'consulting-pmv',
  consulting_pmv_green = <any>'consulting-pmv-green',
  map_pmv = <any>'map-pmv',
  icono_pmv = <any>'icono-pmv',
  edit_pmv_green = <any>'icono-edit-pmv-green',
  consulta_pmv_w = <any>'icono-consulta-pmv-w',
  icono_pmv_w = <any>'icono-pmv-w',
  icono_reload = <any>'icono-reload',
  icon_reset = <any>'icon-reset',
  toggle_off = <any>'toggle_off',
  toggle_on = <any>'toggle_on',
  accident_yellow = <any>'accident_yellow',
  respoonsive_filter = <any>'respoonsive_filter',
  camera_runt_w = <any>'camera_runt_w',
  camera_runt_green = <any>'camera_runt_green',
  last_page_arrow = <any>'last_page_arrow',
  first_page_arrow = <any>'first_page_arrow',
  assignment = <any>'assignment',
  launch = <any>'launch',
  logo_union_europea = <any>'logo-union-europea',
  logo_menu_almeria = <any>'logo-menu-almeria',
  logo_menu_gobierno = <any>'logo-menu-gobierno',
  actions_opts = <any>'actions_opts',
  login_user_y = <any>'login_user_y',
  visibility_y = <any>'visibility_y',
  incidents_y = <any>'incidents_y',
  incidents_24 = <any>'incidents_24',
  settings_y = <any>'settings_y',
  title_panel_matrix = <any>'title_panel_matrix',
  title_panel_matrix_camera = <any>'title_panel_matrix_camera',
  title_panel_situations = <any>'title_panel_situations',
  sensor_matriz_w = <any>'sensor_matriz_w',
  sensor_matriz_y = <any>'sensor_matriz_y',
  expand = <any>'expand',
  expand_b = <any>'expand_b',
  user_y = <any>'user_y',
  previous_page_y = <any>'previous_page_y',
  sucsess_green = <any>'sucsess_green',
  error_red = <any>'error_red',
  calendar_y = <any>'calendar_y',
  calendar_beige = <any>'calendar_beige',
  calendar_w = <any>'calendar_w',
  success_y = <any>'success_y',
  cancel_y = <any>'cancel_y',
  icon_situations_title = <any>'icon-situations-title',
  edit_w = <any>'edit_w',
  alert_y = <any>'alert_y',
  alert = <any>'alert_w',
  camera_y = <any>'camera_y',
  title_panel_traffic = <any>'title_panel_traffic',
  parking_w = <any>'parking_w',
  parking_b = <any>'parking_b',
  parking_y = <any>'parking_y',
  parking_carga_w = <any>'parking-carga_w',
  parking_carga_b = <any>'parking-carga_b',
  parking_carga_y = <any>'parking-carga_y',
  parking_zones_w = <any>'parking-zones_w',
  parking_zones_b = <any>'parking-zones_b',
  parking_zones_y = <any>'parking-zones_y',
  parking_zones_ly = <any>'parking-zones_ly',
  parking_state_green_line = <any>'parking_state_green_line',
  parking_state_blue_line = <any>'parking_state_blue_line',
  parking_state_free = <any>'parking_state_free',
  parking_state_occupied = <any>'parking_state_occupied',
  parking_state_underground = <any>'parking_state_underground',
  parking_state_unknown = <any>'parking_state_unknown',
  parking_state_loading_free = <any>'parking_state_loading_free',
  parking_state_loading_occupied = <any>'parking_state_loading_occupied',
  parking_state_loading_unknown = <any>'parking_state_loading_unknown',
  places = <any>'places',
  map_cluster_parking = <any>'map_cluster_parking',
  places_y = <any>'places_y',
  location_y = <any>'location_y',
  location_beige = <any>'location_beige',
  schedule_y = <any>'schedule_y',
  schedule_yl = <any>'schedule_yl',
  schedule_s = <any>'schedule_s',
  schedule_lv = <any>'schedule_lv',
  ball_green = <any>'ball',
  ball_red = <any>'ball_red',
  ball_orange = <any>'ballOrange',
  ball_blue = <any>'ballBlue',
  sensor_yellow = <any>'capacity_sensor',
  panelPMV = <any>'pmvPanel',
  uploadInput = <any>'uploadFileInput',
  add_image = <any>'add_image',
  plate_y = <any>'plate',
  clean_map = <any>'clean_map',
  luminary_menu = <any>'luminary-menu',
  luminary_menu_b = <any>'luminary-menu_b',
  garbage_menu = <any>'garbage-menu',
  garbage_menu_b = <any>'garbage-menu_b',
  luminary_program = <any>'luminary_program',
  luminary_status = <any>'luminary_status',
  luminary_eye = <any>'eye-visibility_on',
  luminary_sign = <any>'luminary_sign',
  panel_button_icon = <any>'panel-button-panic',

  //menu
  m_audit = <any>'m_audit',
  m_alert = <any>'NotificationsHeaders',
  m_incident = <any>'m_incident',
  m_users = <any>'m_users',
  m_sensor = <any>'m_sensor',
  m_camera = <any>'m_camera',
  m_role = <any>'m_role',


  // Air Quality
  StationPoint = <any>'mini-station',
  StationIconPoint = <any>'mini-station-icon',
  StationIconMap = <any>'StationIconMap',
  StationIconMapGreen = <any>'StationIconMap_Green',
  MiniStationMap = <any>'MiniStationMap',
  Temperature = <any>'temperature',
  Humidity = <any>'humidity',
  Pressure = <any>'pressure',
  AirQuality = <any>'air_D',
  AirQuality_B = <any>'air_D_B',
  AirQuality_Y = <any>'air_D_Y',
  AirQualityTime = <any>'AirQualityTime',
  Station = <any>'station',
  AirQualityGood = <any>'AirQuality_Good',

  // Language
  language_y = <any>'language_y',
  spanish = <any>'spanish',
  english = <any>'english',

  // Top Menú
  home_y = <any>'home_y',
  accessibility_y = <any>'accessibility_y',
  dashboard_white = <any>'icon-dashboard-white',

  //  Notifications
  AirIconNotify = <any>'Air_primary_color',
  CalendarIconNotify = <any>'calendar_Secondary',
  LocationIconNotify = <any>'location_Secondary',
  PanelNotificationsIcon = <any>'NotificationsPanel',
  HeaderNotificationsIcon = <any>'NotificationsHeaders',

  //arrows modal PMV
  top = <any>'TOP',
  left = <any>'LEFT',
  right = <any>'RIGHT',
  u_right = <any>'U_RIGHT',
  u_left = <any>'U_LEFT',
  image = <any>'image',

  // convention Matrix OD
  bar1 = <any>'bar1',
  bar2 = <any>'bar2',
  bar3 = <any>'bar3',
  bar4 = <any>'bar4',
  bar5 = <any>'bar5',
  bar6 = <any>'bar6',
  bar7 = <any>'bar7',
  bar8 = <any>'bar8',
  bar9 = <any>'bar9',
  bar10 = <any>'bar10',

  // convention Matrix OD Camera
  transparent = <any>'transparent',
  bar1Camera = <any>'bar1Camera',
  bar2Camera = <any>'bar2Camera',
  bar3Camera = <any>'bar3Camera',
  bar4Camera = <any>'bar4Camera',
  bar5Camera = <any>'bar5Camera',
  bar6Camera = <any>'bar6Camera',
  bar7Camera = <any>'bar7Camera',
  bar8Camera = <any>'bar8Camera',
  bar9Camera = <any>'bar9Camera',
  bar10Camera = <any>'bar10Camera',

  //PMR layer
  PMR_white = <any>'PMR-menu',
  PMR_black = <any>'PMR-black',
  PMR_Ocupado = <any>'PMR_Ocupado',
  PMR_Disponible = <any>'PMR_Disponible',
  PMR_Indefinido = <any>'PMR_Indefinido',
  trash_layer = <any>'trash-layer',
  identification_card = <any>'IdentificationCard',
  spray_icon = <any>'SprayBottle',
  package_icon = <any>'package',
  ruler_icon = <any>'Ruler',
  placa_icon = <any>'placa',
  trash_icon = <any>'trash_icon',
  vehicle_blue = <any>'vehicle_blue',
  motorcycle_blue = <any>'motorcycle_blue',
  pedestrian_blue = <any>'pedestrian_blue',
  camera_monitoring_blue = <any>'camera_monitoring_blue',
  camera_monitoring_green = <any>'camera_monitoring_green',
  camera_monitoring_red = <any>'camera_monitoring_red',
  camera_map_blue = <any>'camera_map_blue',
  camera_map_green = <any>'camera_map_green',
  camera_map_red = <any>'camera_map_red',
  camera_right_blue = <any>'camera_right_blue',
}

// TODO: Remove map
// export const IconMap: { [key: string]: string } = {
//   [Icon.surface_condition]: `assets/icons.${Icon.surface_condition}.svg`,
// };

export const getIconAsset = (icon: Icon) =>
  Icon[icon]?.indexOf('_ng') > -1 ? undefined : `assets/icons/${icon}.svg`;

export const notFoundClass = 'marker-not-found';

/**
 * Get the icon scss marker class name by Icon
 * @param icon
 * @returns SCSS class name marker
 */
export const getIconClass = (icon: Icon): string =>
  Icon[icon].indexOf('_ng') > -1 ? notFoundClass : `marker-${Icon[icon]}`;
// IconMap[icon] ? `marker-${Icon[icon]}` : notFoundClass;

export const IconMap: { [key: string]: string } = {
  [Icon.surface_condition]: `assets/icons.${Icon.surface_condition}.svg`,
};

export const getIcon = (): { [key: string]: Icon } => ({
  [Icon.m_audit.toString()]: Icon.m_audit,
  [Icon.m_camera.toString()]: Icon.m_camera,
  [Icon.m_incident.toString()]: Icon.m_incident,
  [Icon.m_role.toString()]: Icon.m_role,
  [Icon.m_sensor.toString()]: Icon.m_sensor,
  [Icon.pmv_yellow.toString()]: Icon.pmv_yellow,
  [Icon.m_users.toString()]: Icon.m_users,
});

@Component({ template: '' })
export class IconBaseComponent {
  /**
   * Ipunt property, maps the URL in assets/images to an icon
   */
  @Input() icon: Icon | undefined;
  @Input() alt = '';
  @Input() tabIndex: undefined | number;
  get iconPath(): string | undefined {
    return this.icon ? getIconAsset(this.icon) : undefined;
  }
}
